import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const AddonsViolet = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M8 8.956v3.981l-2.667 1.548c-.412.24-.92.24-1.332 0l-2-1.16a1.343 1.343 0 0 1-.668-1.162V9.73c0-.48.255-.923.668-1.161L4.667 7.02 8 8.956Z"
      fill="#9247C2"
      fillRule="evenodd"
      opacity={0.8}
    />
    <path
      clipRule="evenodd"
      d="M14.667 9.73v2.433c0 .48-.255.922-.668 1.161l-2 1.162c-.412.238-.92.238-1.332 0L8 12.937V8.956l3.333-1.935L14 8.57c.413.239.668.682.668 1.161"
      fill="#9247C2"
      fillRule="evenodd"
      opacity={0.5}
    />
    <path
      clipRule="evenodd"
      d="M11.333 3.835v3.186L8 8.956 4.667 7.02V3.835c0-.48.254-.923.667-1.161l2-1.162c.412-.238.92-.238 1.332 0l2 1.162c.413.238.667.682.667 1.161"
      fill="#9247C2"
      fillRule="evenodd"
    />
  </Icon>
));

export default AddonsViolet;
